import React from 'react';
import ContentLoader from 'react-content-loader';

function ScreenLoad(props) {
    return (
        <div class="content">
            <div class="main-content contentLoader">
                <img src={"/img/preLoader.gif"} />
               
                {/* <ContentLoader
                    speed={1}
                    width={2005.333}
                    height={700}
                    viewBox="0 0 2005.333 700"
                    primaryColor="#002737"
                    secondaryColor="#b0b0b0"
                    {...props}
                >
                        <rect x="3" y="24" rx="12" ry="12" width="1800" height="35" /> 
                        <rect x="3" y="80" rx="12" ry="12" width="1700" height="35" /> 
                        <rect x="3" y="136" rx="12" ry="12" width="1600" height="35" /> 
                        <rect x="3" y="192" rx="12" ry="12" width="1500" height="35" /> 
                        <rect x="3" y="248" rx="12" ry="12" width="1400" height="35" /> 
                        <rect x="3" y="304" rx="12" ry="12" width="1300" height="35" /> 
                        <rect x="3" y="360" rx="12" ry="12" width="1200" height="35" /> 
                        <rect x="3" y="416" rx="12" ry="12" width="1100" height="35" /> 
                        <rect x="3" y="472" rx="12" ry="12" width="1000" height="35" /> 
                        <rect x="3" y="528" rx="12" ry="12" width="900" height="35" /> 
                        <rect x="3" y="584" rx="12" ry="12" width="800" height="35" />                      
                        <rect x="3" y="640" rx="12" ry="12" width="600" height="35" /> 
                </ContentLoader> */}
            </div>
        </div >
    )
}

export default ScreenLoad